import React from "react";
import { Link } from "react-router-dom";

import "./Links.scss";

function GameLinks() {
  return (
    <div className="game-links">
      <div>
        <Link to="/guide">Player's Guide</Link>
      </div>
      <div>
        <Link to="/colophon">Colophon</Link>
      </div>
      <div>
        <Link to="/leaderboard">Leader Board</Link>
      </div>
    </div>
  );
}

export default GameLinks;
